<template lang="html">
  <div class="full-page">
    <i-header :title="$route.query.title" @leftClick="$router.go(-1)">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body >
      <div class="register-box">
        <div class="steps-item" v-for="(item, index) in items" :key="index">
          <div class="item-title">{{item.title}}</div>
          <div class="item-content" v-html="item.content"></div>
        </div>
      </div>
    </i-body>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          title: '预约审核中',
          content: '投资者发起预约申请订单，等待管理人后台审核阶段，投资者可以“取消订单”和“查看订单详情”',
        },
        {
          title: '待托管人审核',
          content: 'UKEY模式下，等待托管人对合同进行确认签署，投资者可以“查看订单详情”',
        },
        {
          title: '待合同签署',
          content: '投资者在待合同签署阶段，需要对订单进行双录（若配置）、风险揭示书签署、合同文件签署',
        },
        {
          title: '待理财师签署',
          content: '私募基金管理人配置了理财师需要签署风险揭示书，等待理财师对风险揭示书签署，投资者可以“上传打款资料”或者“查看订单详情”',
        },
        {
          title: '签约成功',
          content: '三方协议签署成功，投资者可以“查看订单详情”',
        },
        {
          title: '合同信息审核失败',
          content: '管理人预约审核未通过，投资者可以"查看订单详情"',
        },
        {
          title: '订单已取消',
          content: '管理人预约审核未通过，投资者可以"查看订单详情"',
        },
        {
          title: '补充协议确认',
          content: '投资者购买的产品订单有新的补充协议的情况下，投资者需要签署补充协议（签署补充协议、征询意见函）',
        },
        {
          title: '确认中',
          content: '管理人上传生效告知函、托管人确认生效告知函阶段，补充协议状态显示为“确认中”，投资者可查看订单详情',
        },
        {
          title: '公告告知函有效',
          content: '投资者购买的产品订单有新的公告告知，①管理人首页强提示公告信息，投资者需要确认知晓。②订单列表可“查看公告”。',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
  .register-box {
    background: #fff;
    margin: 15px;
    box-shadow: 0 0 6px 0 rgba(0,0,0,0.06);
    border-radius: 2px;
    .steps-item {
      padding: 15px;
      border-bottom: 1px dashed #ccc;
      &:last-child {
        border-bottom: none;
      }
      .item-title {
        font-size: 13px;
        color: #222222;
        margin-bottom: 10px;
      }
      .item-content {
        font-size: 13px;
        color: #999999;
      }
    }
  }
</style>
